import { Option } from "@familyzone/component-library";

export const branches = [
  ["beta-au", "Beta - AU"],
  ["beta-nz", "Beta - NZ"],
  ["beta-uk", "Beta - UK"],
  ["beta-us", "Beta - US"],
  ["ea-au", "Early Access - AU"],
  ["ea-nz", "Early Access - NZ"],
  ["ea-uk", "Early Access - UK"],
  ["ea-us", "Early Access - US"],
  ["ga-au", "General Availability - AU"],
  ["ga-nz", "General Availability - NZ"],
  ["ga-uk", "General Availability - UK"],
  ["ga-us", "General Availability One - US"],
  ["ga-us2", "General Availability Two - US"],
  ["feature-branch", "Feature Branch"],
];

export const branchesMapToOptions: Option[] = branches.map((branch) => ({
  value: branch[0],
  label: branch[1],
}));

export const timesMapToOptions: Option[] = [
  { value: "19:00", label: "19:00" },
  { value: "20:00", label: "20:00" },
  { value: "21:00", label: "21:00" },
  { value: "22:00", label: "22:00" },
  { value: "23:00", label: "23:00" },
  { value: "01:00", label: "01:00" },
  { value: "02:00", label: "02:00" },
  { value: "03:00", label: "03:00" },
  { value: "04:00", label: "04:00" },
  { value: "05:00", label: "05:00" },
  { value: "06:00", label: "06:00" },
  { value: "07:00", label: "07:00" },
  { value: "08:00", label: "08:00" },
  { value: "09:00", label: "09:00" },
];
